import Axios from 'axios'

const axios = Axios.create({
    baseURL: process.env.VUE_APP_URL,
    headers: {
        "Content-type": "application/json"
    }
});

export default axios